import React from 'react';
import {
  ModalOverlay,
  ModalContainer,
  ModalCloseButtonArea,
  ModalCloseButton,
  Header,
  Body,
  Footer,
  ModalItemBg,
} from './styles';
import {
  BdsButton,
  BdsIcon,
  BdsTypo,
  BdsAccordion,
  BdsAccordionHeader,
  BdsAccordionBody,
  BdsAccordionGroup,
} from 'blip-ds/dist/blip-ds-react';

import colors from '../../../../../_colors.module.scss';


interface AccordinProps {
  type: string;
  title: string;
  description: string;
  icon?: string;
}

interface CustomModalWithAccordionProps {
  open: boolean;
  accordionData: AccordinProps[];
  modalTitle?: string;
  modalDescription?: string;
  modalAlert?: string;
  modalAction: string;
  onClose: () => void;
  clickY: number;
}

export const CustomModalWithAccordion: React.FC<CustomModalWithAccordionProps> = ({
  open,
  accordionData,
  modalTitle = 'Título Padrão',
  modalDescription,
  modalAlert,
  modalAction,
  onClose,
  clickY,
}) => {
  if (!open) {
    return null;
  }

  return (
    <ModalOverlay onClick={onClose} $positionY={clickY}>
      <ModalContainer onClick={(e) => e.stopPropagation()} $positionY={clickY}>
        <Header>
          <ModalCloseButtonArea>
            <BdsTypo variant="fs-20" bold="bold" margin={false}>
              {modalTitle}
            </BdsTypo>
            <ModalCloseButton>
              <BdsIcon onClick={onClose} theme="outline" name="close" size="medium" />
            </ModalCloseButton>
          </ModalCloseButtonArea>
        </Header>
        <Body>
          {modalDescription && (
            <BdsTypo variant="fs-14" bold="regular">
              <div dangerouslySetInnerHTML={{ __html: modalDescription }} />
            </BdsTypo>
          )}
          {accordionData && (
            // bds-accordion-group always overwrites each child's own divisor prop with its own on render,
            // so the divisor must be controlled here; divisor={false} below is kept as a no-op safeguard
            // in case that upstream blip-ds behavior changes
            <BdsAccordionGroup collapse="single" divisor={accordionData.length > 1}>
              {accordionData.map((item, index) => (
                <BdsAccordion key={`${item.type}-${item.title}`} startOpen={index === 0} divisor={false}>
                  <BdsAccordionHeader accordionTitle={item.title} icon={item.icon || 'info'} icon-color={colors.Primary} />
                  <BdsAccordionBody>
                    <ModalItemBg>
                      <BdsTypo variant="fs-14" bold="regular">
                        <div dangerouslySetInnerHTML={{ __html: item.description }} />
                      </BdsTypo>
                    </ModalItemBg>
                  </BdsAccordionBody>
                </BdsAccordion>
              ))}
            </BdsAccordionGroup>
          )}
          {modalAlert && (
            <BdsTypo variant="fs-14" bold="regular">
              <div dangerouslySetInnerHTML={{ __html: modalAlert }} />
            </BdsTypo>
          )}
        </Body>
        <Footer>
          <BdsButton onClick={onClose}>{modalAction}</BdsButton>
        </Footer>
      </ModalContainer>
    </ModalOverlay>
  );
};
